(function () {
  // Collection pages: availability / price / gender filters (instant, with live counts, chips, URL state), the quick search and the
  // Sort by listbox. Everything runs on the products already in the page; the sort itself is Shopify's native sort_by (a page load).
  var root = document.getElementById('FFiltersRoot');
  var grid = document.getElementById('FCollectionGrid');
  if (!root || !grid) return;

  var $ = function (s, c) { return (c || root).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };
  var drawer = $('#FFilterDrawer');
  var overlay = $('[data-filter-overlay]');
  var toggleBtn = $('#FFilterToggle');
  var searchInput = $('#FQuickSearch');
  var countEl = $('[data-filter-count]');
  var badge = $('[data-filter-badge]');
  var chipsEl = $('[data-filter-chips]');
  var emptyEl = document.querySelector('[data-filter-empty]');
  var doneLabel = $('[data-filter-done-label]');
  var rangeMin = $('[data-range-input="min"]');
  var rangeMax = $('[data-range-input="max"]');
  var fieldMin = $('[data-price-field="min"]');
  var fieldMax = $('[data-price-field="max"]');
  var fill = $('[data-range-fill]');
  var d = root.dataset;

  // ------------------------------------------------------------------ helpers
  function tpl(str, vars) { return String(str || '').replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, k) { return vars[k] != null ? vars[k] : ''; }); }
  function plural(n, one, other) { return tpl(n === 1 ? one : other, { count: n }); }
  // Same pattern trick as the cart drawer: copy the shop's own money formatting from a formatted sample (layout/theme.liquid).
  function money(kr) {
    var cents = Math.round(kr * 100);
    var p = /^(\D*?)1(\D?)234(\D?)567(\D)89(\D*)$/.exec(String(window.FIORENCI_MONEY_SAMPLE || ''));
    if (p) {
      var whole = String(Math.floor(cents / 100)), frac = ('0' + (cents % 100)).slice(-2);
      if (p[2]) whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, p[2]);
      return p[1] + whole + p[4] + frac + p[5];
    }
    return kr + ' ' + (d.currency || '');
  }

  // ------------------------------------------------------------------ items
  var items = [];
  var lo = 0, hi = 0;
  function readItems() {
    items = $$('[data-card-search]', grid).map(function (el) {
      return { el: el, title: el.getAttribute('data-card-search') || '', price: parseFloat(el.getAttribute('data-price')) || 0,
        avail: el.getAttribute('data-avail') || 'in', genders: (el.getAttribute('data-genders') || '').split(/\s+/).filter(Boolean),
        brand: el.getAttribute('data-brand') || '' };
    });
    var prices = items.map(function (i) { return i.price; });
    lo = prices.length ? Math.floor(Math.min.apply(null, prices)) : 0;
    hi = prices.length ? Math.ceil(Math.max.apply(null, prices)) : 0;
    [rangeMin, rangeMax].forEach(function (r) { r.min = lo; r.max = hi; });
    [fieldMin, fieldMax].forEach(function (f) { f.min = lo; f.max = hi; });
  }

  // ------------------------------------------------------------------ state
  var state = { avail: [], gender: [], min: null, max: null, q: '', brand: '' };
  function fromUrl() {
    var p = new URLSearchParams(window.location.search);
    var list = function (k) { return (p.get(k) || '').split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean); };
    state.avail = list('avail').filter(function (v) { return v === 'in' || v === 'out'; });
    state.gender = list('gender').filter(function (v) { return v === 'men' || v === 'women' || v === 'unisex'; });
    var a = parseFloat(p.get('price_min')), b = parseFloat(p.get('price_max'));
    state.min = isNaN(a) ? null : a; state.max = isNaN(b) ? null : b;
    state.q = (p.get('q') || '').trim();
    state.brand = (p.get('brand') || '').trim().toLowerCase();
  }
  function toUrl() {
    var p = new URLSearchParams(window.location.search);
    ['avail', 'gender', 'price_min', 'price_max', 'q'].forEach(function (k) { p.delete(k); });
    if (state.avail.length) p.set('avail', state.avail.join(','));
    if (state.gender.length) p.set('gender', state.gender.join(','));
    if (state.min != null && state.min > lo) p.set('price_min', String(Math.round(state.min)));
    if (state.max != null && state.max < hi) p.set('price_max', String(Math.round(state.max)));
    if (state.q) p.set('q', state.q);
    var qs = p.toString();
    try { history.replaceState(null, '', window.location.pathname + (qs ? '?' + qs : '') + window.location.hash); } catch (e) {}
  }

  function effMin() { return state.min == null ? lo : Math.max(lo, Math.min(state.min, hi)); }
  function effMax() { return state.max == null ? hi : Math.min(hi, Math.max(state.max, lo)); }
  function priceActive() { return effMin() > lo || effMax() < hi; }

  // does an item pass every active filter except the group named in `skip`?
  function passes(it, skip) {
    if (state.q && it.title.indexOf(state.q.toLowerCase()) === -1) return false;
    if (state.brand && it.brand !== state.brand) return false;
    if (skip !== 'avail' && state.avail.length && state.avail.indexOf(it.avail) === -1) return false;
    if (skip !== 'gender' && state.gender.length && !it.genders.some(function (g) { return state.gender.indexOf(g) > -1; })) return false;
    if (skip !== 'price' && priceActive() && (it.price < effMin() || it.price > effMax())) return false;
    return true;
  }

  // ------------------------------------------------------------------ render
  function render() {
    var shown = 0;
    items.forEach(function (it) { var ok = passes(it); it.el.hidden = !ok; if (ok) shown++; });

    // live counts: each option counts the products that pass all the OTHER filters
    $$('[data-count]').forEach(function (el) {
      var parts = el.getAttribute('data-count').split(':'), group = parts[0], val = parts[1];
      var n = items.filter(function (it) {
        if (!passes(it, group)) return false;
        return group === 'avail' ? it.avail === val : it.genders.indexOf(val) > -1;
      }).length;
      el.textContent = '(' + n + ')';
      var label = el.closest('.f-check'); if (label) label.classList.toggle('is-empty', n === 0 && !label.querySelector('input').checked);
    });

    // controls
    $$('input[data-filter]').forEach(function (cb) { cb.checked = state[cb.getAttribute('data-filter')].indexOf(cb.value) > -1; });
    var a = effMin(), b = effMax();
    rangeMin.value = a; rangeMax.value = b; fieldMin.value = a; fieldMax.value = b;
    var span = Math.max(1, hi - lo);
    fill.style.left = ((a - lo) / span * 100) + '%'; fill.style.right = ((hi - b) / span * 100) + '%';

    // count, badge, empty state, done button
    var text = plural(shown, d.countOne, d.countOther);
    countEl.textContent = text;
    var active = state.avail.length + state.gender.length + (priceActive() ? 1 : 0);
    badge.hidden = active === 0; badge.textContent = active;
    doneLabel.textContent = plural(shown, d.showOne, d.showOther);
    if (emptyEl) emptyEl.hidden = shown !== 0;

    // chips
    chipsEl.textContent = '';
    var chips = [];
    state.avail.forEach(function (v) { chips.push({ label: v === 'in' ? d.lblInStock : d.lblOutOfStock, remove: function () { state.avail = state.avail.filter(function (x) { return x !== v; }); } }); });
    if (priceActive()) chips.push({ label: d.lblFrom + ' ' + money(a) + ' – ' + d.lblTo + ' ' + money(b), remove: function () { state.min = null; state.max = null; } });
    state.gender.forEach(function (v) { chips.push({ label: v === 'men' ? d.lblMen : v === 'women' ? d.lblWomen : d.lblUnisex, remove: function () { state.gender = state.gender.filter(function (x) { return x !== v; }); } }); });
    chips.forEach(function (c) {
      var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'f-chip';
      btn.setAttribute('aria-label', tpl(d.lblRemove, { name: c.label }));
      btn.innerHTML = '<span></span><svg viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="M2 2l8 8M10 2l-8 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" fill="none"/></svg>';
      btn.firstChild.textContent = c.label;
      btn.addEventListener('click', function () { c.remove(); update(); });
      chipsEl.appendChild(btn);
    });
    if (chips.length) {
      var clear = document.createElement('button'); clear.type = 'button'; clear.className = 'f-chips__clear'; clear.textContent = $('[data-filter-clear]').textContent;
      clear.addEventListener('click', clearAll); chipsEl.appendChild(clear);
    }
    chipsEl.hidden = chips.length === 0;
    toUrl();
  }
  function update() { render(); }
  function clearAll() { state.avail = []; state.gender = []; state.min = null; state.max = null; state.q = ''; state.brand = ''; searchInput.value = ''; update(); }

  // ------------------------------------------------------------------ events: filters
  $$('input[data-filter]').forEach(function (cb) {
    cb.addEventListener('change', function () {
      var k = cb.getAttribute('data-filter'), list = state[k].slice(), i = list.indexOf(cb.value);
      if (cb.checked && i === -1) list.push(cb.value); if (!cb.checked && i > -1) list.splice(i, 1);
      state[k] = list; update();
    });
  });
  rangeMin.addEventListener('input', function () { var v = Math.min(parseFloat(rangeMin.value), effMax()); state.min = v; state.max = effMax(); update(); });
  rangeMax.addEventListener('input', function () { var v = Math.max(parseFloat(rangeMax.value), effMin()); state.max = v; state.min = effMin(); update(); });
  function fieldChange(which) {
    return function () {
      var v = parseFloat((which === 'min' ? fieldMin : fieldMax).value);
      if (isNaN(v)) { if (which === 'min') state.min = null; else state.max = null; update(); return; }
      if (which === 'min') { state.min = Math.max(lo, Math.min(v, effMax())); } else { state.max = Math.min(hi, Math.max(v, effMin())); }
      update();
    };
  }
  fieldMin.addEventListener('change', fieldChange('min')); fieldMax.addEventListener('change', fieldChange('max'));
  var qTimer;
  searchInput.addEventListener('input', function () { clearTimeout(qTimer); qTimer = setTimeout(function () { state.q = searchInput.value.trim(); update(); }, 120); });
  $$('[data-filter-clear]').forEach(function (b) { b.addEventListener('click', clearAll); });
  if (emptyEl) $$('[data-filter-clear]', emptyEl).forEach(function (b) { b.addEventListener('click', clearAll); });

  // ------------------------------------------------------------------ drawer: open / close / focus trap
  var lastFocus = null;
  function focusables() { return $$('button, [href], input, summary, select, textarea, [tabindex]:not([tabindex="-1"])', drawer).filter(function (e) { return !e.disabled && e.offsetParent !== null; }); }
  function openDrawer() {
    lastFocus = document.activeElement;
    drawer.hidden = false; overlay.hidden = false;
    document.documentElement.classList.add('f-scroll-lock');
    toggleBtn.setAttribute('aria-expanded', 'true');
    var f = focusables(); if (f.length) f[0].focus();
    document.addEventListener('keydown', onKey);
  }
  function closeDrawer() {
    if (drawer.hidden) return;
    drawer.hidden = true; overlay.hidden = true;
    document.documentElement.classList.remove('f-scroll-lock');
    toggleBtn.setAttribute('aria-expanded', 'false');
    document.removeEventListener('keydown', onKey);
    (toggleBtn || lastFocus).focus();
  }
  function onKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); closeDrawer(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables(); if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || !drawer.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (document.activeElement === last || !drawer.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
  }
  toggleBtn.addEventListener('click', function () { if (drawer.hidden) openDrawer(); else closeDrawer(); });
  overlay.addEventListener('click', closeDrawer);
  $$('[data-filter-close], [data-filter-done]').forEach(function (b) { b.addEventListener('click', closeDrawer); });

  // ------------------------------------------------------------------ sort listbox
  var sortBtn = $('#FSortBtn'), sortList = $('#FSortList');
  var opts = $$('[role="option"]', sortList);
  var activeIdx = 0;
  function setActive(i) {
    activeIdx = Math.max(0, Math.min(opts.length - 1, i));
    opts.forEach(function (o, k) { o.classList.toggle('is-active', k === activeIdx); });
    sortList.setAttribute('aria-activedescendant', opts[activeIdx].id);
    opts[activeIdx].scrollIntoView({ block: 'nearest' });
  }
  function openSort() {
    sortList.hidden = false; sortBtn.setAttribute('aria-expanded', 'true');
    var cur = opts.findIndex(function (o) { return o.getAttribute('aria-selected') === 'true'; });
    setActive(cur < 0 ? 0 : cur); sortList.focus();
  }
  function closeSort(returnFocus) {
    if (sortList.hidden) return;
    sortList.hidden = true; sortBtn.setAttribute('aria-expanded', 'false');
    if (returnFocus) sortBtn.focus();
  }
  function chooseSort(i) {
    var value = opts[i].getAttribute('data-value');
    if (value === d.sortCurrent) { closeSort(true); return; }
    var p = new URLSearchParams(window.location.search); p.set('sort_by', value); p.delete('page');
    window.location.assign(window.location.pathname + '?' + p.toString());   // native Shopify sort; the filter params in the URL are kept
  }
  sortBtn.addEventListener('click', function () { if (sortList.hidden) openSort(); else closeSort(true); });
  sortBtn.addEventListener('keydown', function (e) { if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); if (sortList.hidden) openSort(); } });
  sortList.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowDown') { e.preventDefault(); setActive(activeIdx + 1); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(activeIdx - 1); }
    else if (e.key === 'Home') { e.preventDefault(); setActive(0); }
    else if (e.key === 'End') { e.preventDefault(); setActive(opts.length - 1); }
    else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); chooseSort(activeIdx); }
    else if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); closeSort(true); }
    else if (e.key === 'Tab') { closeSort(false); }
  });
  opts.forEach(function (o, i) { o.addEventListener('click', function () { chooseSort(i); }); o.addEventListener('mousemove', function () { setActive(i); }); });
  document.addEventListener('click', function (e) { if (!sortList.hidden && !e.target.closest('[data-sort]')) closeSort(false); });

  // ------------------------------------------------------------------ start: read the URL, merge further pages, render
  readItems();
  fromUrl();
  if (state.q) searchInput.value = state.q;
  render();

  var pages = parseInt(grid.getAttribute('data-pages'), 10) || 1, current = parseInt(grid.getAttribute('data-page'), 10) || 1;
  if (pages > 1) {
    var nav = document.querySelector('[data-pagination]');
    var sortBy = new URLSearchParams(window.location.search).get('sort_by');
    var jobs = [];
    for (var pg = 1; pg <= pages; pg++) {
      if (pg === current) continue;
      (function (n) {
        var p = new URLSearchParams(); if (sortBy) p.set('sort_by', sortBy); p.set('page', n);
        jobs.push(fetch(window.location.pathname + '?' + p.toString(), { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          return { n: n, cards: $$('#FCollectionGrid > [data-card-search]', doc) };
        }).catch(function () { return { n: n, cards: [] }; }));
      })(pg);
    }
    Promise.all(jobs).then(function (res) {
      res.sort(function (a, b) { return a.n - b.n; });
      res.forEach(function (r) { r.cards.forEach(function (c) { (r.n > current ? grid.appendChild(document.importNode(c, true)) : grid.insertBefore(document.importNode(c, true), grid.firstChild)); }); });
      if (nav) nav.hidden = true;
      readItems(); render();
      document.dispatchEvent(new CustomEvent('fiorenci:cards-added'));
    });
  }
})();
